import qs from 'qs'
import To from 'await-to-js'
import Callback from '@/services/Callback'
import { wizStandardInstance } from './instance'

export default class DataApprovalService {
  // 获取批次信息
  static async getBatchInfo(payload) {
    const [err, res] = await To(wizStandardInstance.get(`/api/std/DataBatch/${payload.id}`))
    return Callback(err, res)
  }

  // 获取批次下的实体列表
  static async getBatchEntity(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataBatch/get-batch-entity', payload)
    )
    return Callback(err, res)
  }

  // 获取批次的某实体的数据
  static async getBatchEntityData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataBatch/get-batch-entity-data', payload)
    )
    return Callback(err, res)
  }

  // 获取实体数据管理动态表头
  static async getDynamicTableHeader(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(
        `/api/std/StdClassData/dynamic-table-header-info?${qs.stringify(payload)}`
      )
    )
    return Callback(err, res)
  }

  // 数据批次审批
  static async batchApprove(payload) {
    const [err, res] = await To(wizStandardInstance.post('/api/std/DataBatch/approve', payload))
    return Callback(err, res)
  }

  // 批次审批数据编辑
  static async updateBatchData(payload) {
    const [err, res] = await To(
      wizStandardInstance.post('/api/std/DataBatch/update_batch_data', payload)
    )
    return Callback(err, res)
  }

  // 批次审批数据重新提交审核
  static async batchDataReapply(payload) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/DataBatch/reapply?${qs.stringify(payload)}`)
    )
    return Callback(err, res)
  }
}
